import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getSiteConfig, getCategories } from '../api';
import './Footer.css';

// 递归扁平化分类树
function flattenTree(tree, results = []) {
  if (!tree) return results;
  tree.forEach(node => {
    results.push(node);
    if (node.children && node.children.length > 0) {
      flattenTree(node.children, results);
    }
  });
  return results;
}

const DEFAULT_CONFIG = {
  site_name: '河南和正网络科技有限公司',
  address_yunnan: '',
  phone_yunnan: '',
  contact_email: '',
  service_hotline: '',
  icp_number: '',
};

export default function Footer() {
  const year = new Date().getFullYear();
  const [cfg, setCfg] = useState(DEFAULT_CONFIG);
  const [industryLinks, setIndustryLinks] = useState([]);
  const [productLinks, setProductLinks] = useState([]);

  useEffect(() => {
    getSiteConfig().then(data => {
      if (data && typeof data === 'object') {
        setCfg(prev => ({ ...prev, ...data }));
      }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    // 使用 v2.0 分类树 API，替代旧的 getIndustries()
    getCategories().then(tree => {
      const industries = [];
      const products = [];
      const flat = flattenTree(tree || []);
      flat.forEach(cat => {
        const item = { label: cat.name, to: `/category/${cat.id}` };
        if (cat.type === 'industry') industries.push(item);
        else products.push(item);
      });
      setIndustryLinks(industries);
      setProductLinks(products);
    }).catch(() => {});
  }, []);

  return (
    <footer className="footer">
      <div className="footer-main container">
        <div className="footer-col footer-brand">
          <div className="footer-logo">{cfg.site_name || DEFAULT_CONFIG.site_name}</div>
          <p className="footer-desc">专注于数字化解决方案，服务各行业客户</p>
        </div>

        <div className="footer-col">
          <h4>行业方案</h4>
          {industryLinks.map((item, idx) => (
            <Link key={idx} to={item.to}>{item.label}</Link>
          ))}
        </div>

        <div className="footer-col">
          <h4>产品方案</h4>
          {productLinks.map((item, idx) => (
            <Link key={idx} to={item.to}>{item.label}</Link>
          ))}
        </div>

        <div className="footer-col">
          <h4>关于我们</h4>
          <Link to="/about">企业简介</Link>
          <Link to="/about/partner">生态伙伴</Link>
          <Link to="/about/qualification">资质荣誉</Link>
          <Link to="/recruit">加入我们</Link>
        </div>

        <div className="footer-col">
          <h4>联系我们</h4>
          {cfg.address_yunnan && <p>公司地址：{cfg.address_yunnan}</p>}
          {cfg.phone_yunnan && <p>电话：{cfg.phone_yunnan}</p>}
          {cfg.contact_email && <p>联系邮箱：{cfg.contact_email}</p>}
          {cfg.service_hotline && <p>服务热线：{cfg.service_hotline}</p>}
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <span>Copyright © {year} {cfg.site_name || DEFAULT_CONFIG.site_name} 版权所有</span>
          {cfg.icp_number && <span>{cfg.icp_number}</span>}
          <Link to="/privacy">隐私政策</Link>
        </div>
      </div>
    </footer>
  );
}
